import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import FormText from './FormText.js';
import FormColor from './FormColor.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function MusclegroupNew({showNew, closeNew, updateMusclegroupRowNew, targetUsrId = 0}) {
	const popupAnimationMs = 300;
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState('');
	const [nameError, setNameError] = useState('');
	const [color, setColor] = useState('#999900');
	const [colorError, setColorError] = useState('');

	const nameRef = useRef(null);
	const colorRef = useRef(null);
	const {shouldRender, isClosing} = usePopupAnimation(showNew, popupAnimationMs);

	useEffect(() => {
		setName('');
		setColor('#999900');
	}, [showNew]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setNameError('');
		setColorError('');

		let localError = 0;

		if (!name) {
			localError = 1;
			setNameError('povinné');
			nameRef.current.focus();
		}

		if (localError === 0) {
			setLoading(true);
			const payload = {NAME: name, COLOR: color};

			if (targetUsrId > 0) {
				payload.USRID = targetUsrId;
			}

			post('saveMusclegroupNew', payload)
				.then((res) => {
					closeNew();

					if (res.data > 0) {
						updateMusclegroupRowNew({ID: res.data, NAME: name, COLOR: color, data_graph: {data: [], labels: []}});
					}

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	return (
		<>
			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Nova svalová partie</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeNew();
									}}
								/>
							</div>
							<div className="popup_content_in_body">
								<div className="popup_content_in_body_in">
									<FormText type="text" label="Název" value={name} setValue={setName} ref={nameRef} error={nameError} />
									<div className="zero h0" />

									<FormColor type="text" label="Barva" value={color} setValue={setColor} ref={colorRef} error={colorError} />
									<div className="zero h0" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={loading} />
									<button
										type="button"
										className="button"
										onClick={() => {
											closeNew();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
